import { render } from "./SettingsPermissionsEdit.vue?vue&type=template&id=d605e87a&scoped=true"
import script from "./SettingsPermissionsEdit.vue?vue&type=script&lang=js"
export * from "./SettingsPermissionsEdit.vue?vue&type=script&lang=js"

import "./SettingsPermissionsEdit.vue?vue&type=style&index=0&id=d605e87a&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Tomi\\PhpstormProjects\\frontend-v2\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d605e87a"]])

export default __exports__